<template>
  <div class="mobile" :class="{ 'mobile--small': type === 'small' }">
    <!--Layout chat-->
    <template v-if="layout === 'chat'">
      <img
        v-if="type === 'default'"
        src="@/app/strategies/assets/mobile.svg"
        class="mobile__picture"
      />
      <img
        v-if="type === 'small'"
        src="@/app/shared/assets/mobile-small.svg"
        class="mobile__picture"
      />
      <div class="mobile__container scrollbar_basic">
        <div
          class="mobile__bubble text--left"
          :class="{
            'mobile__default-message': !message,
            mobile__message: message,
          }"
        >
          {{ message || defaultMessage }}
        </div>
      </div>
    </template>
    <template v-else-if="layout === 'profile'">
      <svg width="224" height="450" viewBox="0 0 224 450" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'small'" v-bind:svg-inline="''" v-bind:class="'mobile__picture'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><rect width="224" height="450" rx="24" fill="#1F232E"/><path fill="#292F3F" d="M0 0h224v28H0z"/><path d="M18.842 18v-7.336h-.024l-2.238 1.611v-1.113l2.25-1.617h1.031V18h-1.02zm6.223.146c-.633 0-1.192-.164-1.676-.492-.485-.332-.858-.802-1.12-1.412-.277-.64-.415-1.416-.415-2.326 0-1.426.287-2.535.86-3.328.579-.793 1.386-1.19 2.42-1.19.72 0 1.333.2 1.84.598.508.399.83.93.967 1.594H26.87a1.676 1.676 0 00-.644-.914 1.821 1.821 0 00-1.102-.346c-.707 0-1.254.303-1.64.908-.387.606-.59 1.471-.61 2.596h.018a2.22 2.22 0 01.931-.996 2.79 2.79 0 011.43-.375c.805 0 1.473.266 2.004.797.535.531.803 1.197.803 1.998 0 .836-.284 1.527-.85 2.074-.563.543-1.277.814-2.145.814zm-1.383-1.5c.375.375.832.563 1.37.563.54 0 .997-.186 1.372-.557a1.84 1.84 0 00.562-1.359c0-.555-.18-1.01-.539-1.365-.36-.36-.818-.54-1.377-.54-.558 0-1.023.178-1.394.534-.367.355-.551.803-.551 1.342 0 .543.186 1.004.557 1.383zm6.82-.246a.646.646 0 01-.475.194.645.645 0 01-.474-.194.645.645 0 01-.194-.474c0-.188.065-.346.194-.475a.645.645 0 01.474-.193c.188 0 .346.064.475.193a.645.645 0 01.193.475.645.645 0 01-.193.474zm0-4.312a.646.646 0 01-.475.193.645.645 0 01-.474-.193.645.645 0 01-.194-.475c0-.187.065-.345.194-.474a.645.645 0 01.474-.194c.188 0 .346.065.475.194a.645.645 0 01.193.474.645.645 0 01-.193.475zm3.457 2.01v-.891h1.014c.484 0 .88-.139 1.19-.416a1.38 1.38 0 00.462-1.066c0-.43-.143-.772-.428-1.026-.285-.254-.69-.38-1.213-.38-.484 0-.879.128-1.183.386-.305.258-.48.61-.528 1.055H32.26c.058-.719.336-1.291.832-1.717.5-.426 1.146-.639 1.94-.639.761 0 1.394.205 1.898.616.504.41.755.931.755 1.564 0 .527-.156.97-.468 1.33-.313.36-.735.586-1.266.68v.023c.64.04 1.15.244 1.53.615.378.368.568.848.568 1.442 0 .473-.133.898-.399 1.277a2.61 2.61 0 01-1.078.88c-.453.206-.955.31-1.506.31-.875 0-1.58-.22-2.115-.657-.535-.437-.822-1.011-.861-1.722h1.013c.047.441.245.797.592 1.066.348.266.801.399 1.36.399.558 0 1.017-.143 1.377-.428.363-.285.545-.649.545-1.09 0-.496-.176-.889-.528-1.178-.347-.289-.824-.433-1.43-.433h-1.06zm8.338 4.043c-.98 0-1.746-.391-2.297-1.172-.547-.785-.82-1.852-.82-3.2 0-1.335.275-2.396.826-3.181.554-.79 1.318-1.184 2.29-1.184.974 0 1.733.393 2.28 1.178.551.781.826 1.842.826 3.182 0 1.347-.273 2.414-.82 3.199-.547.785-1.309 1.178-2.285 1.178zm-1.518-1.846c.36.617.865.926 1.518.926.652 0 1.156-.307 1.512-.92.355-.617.533-1.461.533-2.531 0-1.055-.18-1.891-.54-2.508-.359-.621-.86-.932-1.505-.932-.645 0-1.149.31-1.512.932-.363.62-.545 1.455-.545 2.502 0 1.07.18 1.914.54 2.53zm8.432-6.75h3.017c.794 0 1.442.254 1.946.762.508.503.761 1.154.761 1.95 0 .802-.253 1.456-.761 1.964s-1.16.761-1.957.761h-1.951V18H49.21V9.545zm1.055.937v3.563h1.687c.602 0 1.069-.156 1.4-.469.332-.316.499-.756.499-1.318 0-.563-.166-.998-.498-1.307-.329-.312-.795-.469-1.4-.469h-1.688zM64.48 18h-.985v-6.516h-.04l-2.696 6.457h-.89l-2.696-6.457h-.041V18h-.985V9.545h1.225l2.918 7.055h.047l2.918-7.055h1.225V18zM176.857 12.83l1.013.991c2.518-2.465 6.6-2.465 9.117 0L188 12.83c-3.074-3.01-8.063-3.01-11.143 0zm4.052 3.967l1.52 1.489 1.519-1.489a2.178 2.178 0 00-3.039 0zm-2.026-1.984l1.013.992a3.637 3.637 0 015.065 0l1.013-.992c-1.955-1.914-5.13-1.914-7.091 0zM162.608 17.429h1.928v-5.786h-1.928v5.786zm-2.893 0h1.928v-3.857h-1.928v3.857zm5.786-7.715v7.715h1.928V9.714h-1.928zM206.114 15.888v-.86h1.029v-2.056h-1.029v-.86a.687.687 0 00-.684-.683h-7.884a.688.688 0 00-.689.684v3.77c0 .38.308.689.684.689h7.889a.687.687 0 00.684-.684z" fill="#fff"/></svg>
      <div class="mobile__container mobile__container--profile scrollbar_basic">
        <!--Primera seccion-->
        <div class="text--center mobile__row">
          <div class="mobile__main-data">
            <div class="mobile__avatar-container mrg-bottom-8">
              <img
                :src="profile.avatar"
                height="48px"
                width="48px"
                alt="Avatar"
                class="mobile__avatar"
              />
            </div>
            <h6 class="semibold-14 mobile__name mrg-bottom-0">
              {{ profile.name }}
            </h6>
          </div>
          <a-divider class="mobile__divider" />
          <a-row
            type="flex"
            align="middle"
            justify="space-between"
            class="general-padding"
          >
            <p class="regular-12 mrg-bottom-0 gray-light-500">
              Esta es una cuenta de empresa
            </p>
            <a-icon type="info-circle" class="link-whatsapp" />
          </a-row>
        </div>
        <!--Segunda seccion-->
        <div class="mobile__row text--left general-padding regular-12">
          <p class="regular-12 mrg-bottom-8">
            {{ profile.description }}
          </p>
          <p class="link-whatsapp mrg-bottom-4">
            {{ profile.address }},
            {{ profile.city }}
          </p>
          <p class="link-whatsapp mrg-bottom-12">
            {{ profile.zipcode }}
            <br />
            {{ profile.country }}
          </p>
          <p class="link-whatsapp mrg-bottom-4">
            {{ profile.email }}
          </p>
          <p class="link-whatsapp mrg-bottom-0">
            {{ profile.website }}
          </p>
        </div>
        <!--Tercera seccion-->
        <div class="mobile__row general-padding">
          <h6 class="semibold-12 mrg-bottom-8 gray-light-500">
            Info. y número de teléfono
          </h6>
          <p class="regular-14">{{ profile.about }}</p>
          <span class="regular-12 gray-light-500">{{
            profile.approvedAt
          }}</span>
          <a-divider class="mobile__divider" />
          <p class="regular-14 mobile__number">{{ profile.name }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MobileWsp',
  props: {
    // mensaje customizado
    message: {
      type: String,
      required: false,
      default: null,
    },
    // mensaje por defecto
    defaultMessage: {
      type: String,
      required: false,
      default:
        'Selecciona una plantilla, para previsualizar el contenido de una plantilla.',
    },
    type: {
      type: String,
      required: false,
      default: 'default',
      enum: ['default', 'small'],
    },
    layout: {
      type: String,
      required: false,
      default: 'chat',
      enum: ['chat', 'profile'],
    },
    dataSourceProfile: {
      type: Object,
      required: false,
    },
  },
  computed: {
    profile() {
      const profile = {}
      for (let property in this.dataSourceProfile) {
        profile[property] =
          this.dataSourceProfile[property] &&
          this.dataSourceProfile[property].length > 0
            ? this.dataSourceProfile[property]
            : '...'
      }
      return profile
    },
  },
}
</script>

<style lang="sass" scoped>
$background_profile: #1A1E27
$link_whatsapp: #02A386

.general-padding
  padding: 8px 12px
.link-whatsapp
  color: $link_whatsapp
.gray-light-500
  color: $gray_light_500

.mobile
  position: relative
  &__picture
    border-radius: 40px
    box-shadow: 10px 10px 50px rgba(24, 48, 63, 0.5);
  &__container
    position: absolute
    top: 80px
    left: 0px
    padding: 14px 12px
    width: 100%
    overflow-y: auto
    height: 33em
    margin-top: 2px
    &--profile
      color: $gray_2
      top: 28px!important
      padding: 0px!important
      height: 28em!important
  &__name
    color: $gray_2
  &__divider
    margin: 0px
    background-color: $gray_light_900
  &__row
    background-color: $background_profile
    margin-bottom: 12px
    &:last-child
      margin-bottom: 0px
  &__main-data
    padding: 12px
  &__number
    margin: 12px 0px
  &__mobile__avatar-container
    height: 64px
    width: 64px
    background-color: $gray_9
  &__bubble
    border-radius: 20px
    background-color: #373E4E
    max-width: 240px
    color: $gray_1
    padding: 12px
  &__default-message
    color: $gray_7
  &--small
    width: fit-content
    .mobile
      &__picture
        border-radius: 24px
      &__container
        top: 64px
        height: 24em
</style>
